import { action } from 'typesafe-actions';
import { AuthenticationActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const resetAuthenticateErrors = (): any => action(types.RESET_AUTHENTICATE_ERRORS);

export const refreshUser = (response): any => action(types.REFRESH_COGNITO_USER_REQUESTED, response);

export const authenticateCognitoUser = (user, findUser = true): any => action(types.AUTHENTICATE_COGNITO_USER_REQUESTED, { user, findUser });

export const forgotPassword = (user): any => action(types.FORGOT_PASSWORD_REQUESTED, { user });

export const changePassword = (user, callback): any => action(types.CHANGE_PASSWORD_REQUESTED, {
  user,
  callback,
});

export const logoutUser = (
  redirectLocation = undefined,
  redirect = true,
): any => action(types.USER_LOGOUT_REQUESTED, {
  redirectLocation,
  redirect,
});

export const refreshOrLogoutUser = (
  redirectLocation = undefined,
  redirect = true,
): any => action(types.REFRESH_OR_LOGOUT_REQUESTED, {
  redirectLocation,
  redirect,
});

export const registerMobileDeviceToken = (
  token: string,
  deviceType: string,
): any => action(types.REGISTER_MOBILE_DEVICE_TOKEN_REQUESTED, {
  token,
  deviceType,
});

export const switchUser = (userId): any => action(types.SWITCH_USER, {
  userId,
});

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  authenticateCognitoUserPending: (): any => action(types.AUTHENTICATE_COGNITO_USER_PENDING),
  authenticateCognitoUserSuccess: (response): any => action(types.AUTHENTICATE_COGNITO_USER_SUCCESS, response),
  authenticateCognitoUserFailed: (error): any => action(types.AUTHENTICATE_COGNITO_USER_FAIL, {
    backendErrors: {
      message: error,
    },
  }),
  registerMobileDeviceTokenPending: (): any => action(types.REGISTER_MOBILE_DEVICE_TOKEN_PENDING),
  registerMobileDeviceTokenSuccess: (response): any => action(types.REGISTER_MOBILE_DEVICE_TOKEN_SUCCESS, response),
  registerMobileDeviceTokenFailed: (error): any => action(types.REGISTER_MOBILE_DEVICE_TOKEN_FAIL, {
    backendErrors: {
      message: error,
    },
  }),
  forgotPasswordPending: (): any => action(types.FORGOT_PASSWORD_PENDING, {}),
  forgotPasswordSuccess: (response): any => action(types.FORGOT_PASSWORD_SUCCESS, response),
  forgotPasswordFailed: (error): any => action(types.FORGOT_PASSWORD_FAIL, {
    backendErrors: {
      message: error,
    },
  }),
  changePasswordPending: (): any => action(types.CHANGE_PASSWORD_PENDING),
  refreshUserSuccess: (response): any => action(types.REFRESH_COGNITO_USER_SUCCESS, response),
  userLogout: (response): any => action(types.USER_LOGOUT, response),
  changePasswordSuccess: (response): any => action(types.CHANGE_PASSWORD_SUCCESS, response),
  changePasswordFailed: (error): any => action(types.CHANGE_PASSWORD_FAIL, {
    backendErrors: {
      message: error,
    },
  }),
};

export default null;
